import { render, staticRenderFns } from "./systemVideo.vue?vue&type=template&id=31ef7b7f&scoped=true"
import script from "./systemVideo.vue?vue&type=script&lang=js"
export * from "./systemVideo.vue?vue&type=script&lang=js"
import style0 from "./systemVideo.vue?vue&type=style&index=0&id=31ef7b7f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ef7b7f",
  null
  
)

export default component.exports